import * as React from 'react';
import { SelectorProps } from './selectors';
import classNames from 'classnames';
import './flatSelector.module.scss';

const SelectorOption = ({ label, active, onClick }) => (
  <div styleName={classNames('selector-option', { active: active })} onClick={active ? undefined : onClick}>
    {label}
  </div>
);

export class FlatSelector<T extends string> extends React.Component<SelectorProps<T>> {
  render() {
    const { value, options, className, onChange } = this.props;
    return (
      <div styleName="flat-selector" className={className}>
        {options.map((option) => (
          <SelectorOption
            key={option.label || 'null'}
            label={option.label}
            active={option.value === value}
            onClick={() => onChange(option.value)}
          />
        ))}
      </div>
    );
  }
}
